window.GlobalDate = {
  newDate(dateString) {
    if (dateString) return new Date(dateString)
    return new Date()
  },

  dateNow() {
    return Date.now()
  },
}
